"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Quote, Star } from "lucide-react";
export default function CustomerTestimonials() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const testimonials = [{
    id: 1,
    quote: "Outstanding service and attention to detail. They transformed our vision into reality beyond our expectations.",
    name: "Sarah Mitchell",
    rating: 5
  }, {
    id: 2,
    quote: "Professional, reliable, and creative. Working with this team was an absolute pleasure from start to finish.",
    name: "James Rodriguez",
    rating: 5
  }, {
    id: 3,
    quote: "Exceptional quality and timely delivery. Their expertise made all the difference in our project success.",
    name: "Emily Chen",
    rating: 5
  }];
  return <section id="customer-testimonials" className="bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-center text-foreground mb-12 bg-background">
          Customer Testimonials
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div ref={ref1} data-index={0} className={`bg-background rounded-lg p-8 shadow-[0_2px_6px_rgba(0,0,0,0.15)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_12px_rgba(0,0,0,0.2)] group ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: isVisible1 ? "0ms" : "0ms"
        }}>
            <Quote className="text-accent-dark w-10 h-10 mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[5deg]" aria-hidden="true" />
            <p className="text-foreground mb-6 leading-relaxed">
              {testimonials[0].quote}
            </p>
            <div className="flex items-center justify-between">
              <p className="text-accent-dark font-semibold">{testimonials[0].name}</p>
              <div className="flex gap-0.5" aria-label={`Rating: ${testimonials[0].rating} out of 5 stars`}>
                {Array.from({
                length: testimonials[0].rating
              }).map((_, i) => <Star key={i} className="w-4 h-4 fill-accent-dark text-accent-dark" aria-hidden="true" />)}
              </div>
            </div>
          </div>

          <div ref={ref2} data-index={1} className={`bg-background rounded-lg p-8 shadow-[0_2px_6px_rgba(0,0,0,0.15)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_12px_rgba(0,0,0,0.2)] group ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: isVisible2 ? "120ms" : "0ms"
        }}>
            <Quote className="text-accent-dark w-10 h-10 mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[5deg]" aria-hidden="true" />
            <p className="text-foreground mb-6 leading-relaxed">
              {testimonials[1].quote}
            </p>
            <div className="flex items-center justify-between">
              <p className="text-accent-dark font-semibold">{testimonials[1].name}</p>
              <div className="flex gap-0.5" aria-label={`Rating: ${testimonials[1].rating} out of 5 stars`}>
                {Array.from({
                length: testimonials[1].rating
              }).map((_, i) => <Star key={i} className="w-4 h-4 fill-accent-dark text-accent-dark" aria-hidden="true" />)}
              </div>
            </div>
          </div>

          <div ref={ref3} data-index={2} className={`bg-background rounded-lg p-8 shadow-[0_2px_6px_rgba(0,0,0,0.15)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_4px_12px_rgba(0,0,0,0.2)] group ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: isVisible3 ? "240ms" : "0ms"
        }}>
            <Quote className="text-accent-dark w-10 h-10 mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[5deg]" aria-hidden="true" />
            <p className="text-foreground mb-6 leading-relaxed">
              {testimonials[2].quote}
            </p>
            <div className="flex items-center justify-between">
              <p className="text-accent-dark font-semibold">{testimonials[2].name}</p>
              <div className="flex gap-0.5" aria-label={`Rating: ${testimonials[2].rating} out of 5 stars`}>
                {Array.from({
                length: testimonials[2].rating
              }).map((_, i) => <Star key={i} className="w-4 h-4 fill-accent-dark text-accent-dark" aria-hidden="true" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}